import { API } from "@/App";
import { FileBox, FileText, Presentation, Video, Mail, Briefcase, BookOpen, Layout, Building, Target, User } from "lucide-react";

export const ARTIFACT_TYPES = {
  pitch_deck: { name: "Pitch Deck", formats: ["pptx", "pdf"], icon: Presentation },
  prfaq: { name: "PRFAQ Document", formats: ["pdf", "docx"], icon: FileText },
  one_pager: { name: "Executive One-Pager", formats: ["pdf", "docx"], icon: FileText },
  email_sequence: { name: "Email Sequence", formats: ["docx", "html"], icon: Mail },
  proposal: { name: "Sales Proposal", formats: ["pdf", "docx", "pptx"], icon: Briefcase },
  case_study: { name: "Case Study", formats: ["pdf", "docx"], icon: BookOpen },
  video: { name: "Video", formats: ["mp4"], icon: Video },
  prototype: { name: "Clickable Prototype", formats: ["html"], icon: Layout },
};

const KIND = { presentation: "slides", pptx: "slides", document: "doc", pdf: "doc", docx: "doc", prfaq: "doc", video: "video", mp4: "video", html: "html" };
const STYLE = {
  slides: { Icon: Presentation, text: "text-orange-400", badge: "bg-orange-500/20 text-orange-400 border-orange-500/30" },
  doc: { Icon: FileText, text: "text-ism-teal", badge: "bg-ism-teal/20 text-ism-teal border-ism-teal/30" },
  video: { Icon: Video, text: "text-red-400", badge: "bg-red-500/20 text-red-400 border-red-500/30" },
  html: { Icon: Layout, text: "text-purple-400", badge: "bg-purple-500/20 text-purple-400 border-purple-500/30" },
  file: { Icon: FileBox, text: "text-gray-400", badge: "bg-gray-500/20 text-gray-400 border-gray-500/30" },
};

export const artifactStyle = (type) => STYLE[KIND[type] || "file"];

const MENTION_ICONS = { account: Building, opportunity: Target, prospect: User };
export const MentionIcon = ({ type }) => {
  const Icon = MENTION_ICONS[type] || FileBox;
  return <Icon className="h-3 w-3" />;
};

export const formatArtifactDate = (dateString) =>
  dateString ? new Date(dateString).toLocaleDateString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export const withAuth = (path) => {
  const token = localStorage.getItem("authToken");
  return `${API}${path}${path.includes("?") ? "&" : "?"}token=${encodeURIComponent(token || "")}`;
};
